"use client"
import React, { useRef } from "react";

import "@/components/shared/TextSearchInputField.css";

const TextSearchInputField = ({
  left,
  right,
  className,
  inputRef,
  onChange,
  placeholder,
  minLength = 3
}) => {
  var lastTimestamp = null;

  const inputField = useRef();

  const handleTextFilterChange = evt => {
    const input = evt.target.value;
    if (input.length === 0) {
      onChange(null);
      setTimeout(() => {
        onChange(null);
      }, 1000);
    } else {
      var anow = Date.now();
      lastTimestamp = anow;
      setTimeout(() => {
        var now = Date.now();
        if (lastTimestamp && now - lastTimestamp >= 1000) {
          if (input.length > minLength - 1) {
            onChange(input);
          } else {
            // do nothing and wait for user to type more
          }
        }
      }, 1000);
    }
  };

  return (
    <div
      className={`form-control text-search-input-field ${className}`}
    >
      {left ?? (
        <span className="material-icons">
          search
        </span>
      )}
      <input
        ref={inputRef ?? null}
        name="textSearch"
        className="no-style"
        placeholder={placeholder ?? "Search.."}
        onChange={handleTextFilterChange}
      />
      {right ?? <></>}
    </div>
  );
};
export default TextSearchInputField;
